<template>
  <div>
    <Dialog :title="jsonModalTitle" :value="showModal" @close-dialog="closeModal" width="90%">
      <template v-slot:card-text>
          <div v-if="messageString">
            <MonacoEditor :height="editorHeight" language="json" :value="messageString" :options="monacoOptions" />
          </div>
          <div v-else>
            <Loading :size="64" class="text-center" />
          </div>
      </template>
      <template v-slot:card-actions>
          <v-btn color="secondary" text type="button" @click="closeModal">Close</v-btn>
      </template>
    </Dialog>
    <v-container>
      <v-card class="mb-4">
        <v-card-text>
          <ResultsTable :tableHeaders="tableHeaders" :results="messageQueueDeadLetters"
            :loading="messageQueueDeadLettersLoading"
            @update:pagination="onPaginationChange">

            <template v-slot:[`header.Actions`]>
              <v-checkbox
                :input-value="allSelected"
                :indeterminate="someSelected"
                @change="toggleSelectAll"
                color="primary"
                hide-details
              ></v-checkbox>
            </template>

            <template v-slot:Actions="{ item }">
              <v-checkbox v-model="selectedItems" :value="item.Id" color="primary" class="fs-ignore-rage-clicks" hide-details></v-checkbox>
            </template>

            <template v-slot:Id="{ item }">
              <span>{{ item.Id }}</span>
            </template>

            <template v-slot:Message="{ item }">
              <!-- TODO: Why is this component getting wider with each row?  -->
              <MonacoEditor language="json" width="750px" :value="item.Message" :options="monacoOptions" />
            </template>

            <template v-slot:MessageDetails="{ item }">
              <v-btn x-small color="secondary" @click="openJsonModal(item)" v-if="isAdminOrSupport">
                Message JSON
              </v-btn>
            </template>
          </ResultsTable>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>

import MonacoEditor from 'monaco-editor-vue';
import ResultsTable from '@/components/shared/ResultsTable.vue';
import Dialog from '@/components/shared/Dialog.vue';

export default {
  name: 'MessageQueueDeadLettersTable',
  components: {
    MonacoEditor,
    ResultsTable,
    Dialog
  },
  props: {
    messageQueueDeadLettersLoading: Boolean,
    messageQueueDeadLetters: [],
    initialSelectedItems: {
      type: Array,
      default: () => [] // Default value if not provided by parent
    }
   // checkedItems: []

  },
  data () {
    return {
      tableHeaders: [
        { text: "Actions", value: "Actions", sortable: false, filterable: false, width: "80px" },
        { text: "Id", value: "Id", sortable: true, filterable: true, key: 'Id' },
        { text: "Message Contents", value: "Message", sortable: true, filterable: true, key: 'Message' },
        { text: "Message Details", value: "MessageDetails", sortable: false, filterable: false }
      ],
      monacoOptions: {
        colorDecorators: true,
        automaticLayout: true,
        readOnly: true
      },
      selectedItems: this.initialSelectedItems,
      showModal: false,
      jsonModalTitle: "",
      messageString: null,
      message: null,
      editorHeight: `${(window.innerHeight) * 0.60}px`,
      currentPage: 1,
      itemsPerPage: 10,
      filteredItems: []
    };
  },
  computed: {
    isAdminOrSupport () {
      return (this.$store.getters.getUserRole == 'admin' || this.$store.getters.getUserRole == 'support');
    },
    visibleItems () {
      const itemsToUse = this.filteredItems.length > 0 ? this.filteredItems : this.messageQueueDeadLetters;
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = this.itemsPerPage === -1 ? itemsToUse.length : start + this.itemsPerPage;
      return itemsToUse.slice(start, end);
    },
    visibleItemIds () {
      return this.visibleItems.map(item => item.Id);
    },
    allSelected () {
      return this.visibleItems.length > 0 &&
             this.visibleItemIds.every(id => this.selectedItems.includes(id));
    },
    someSelected () {
      const selectedVisibleCount = this.visibleItemIds.filter(id => this.selectedItems.includes(id)).length;
      return selectedVisibleCount > 0 && selectedVisibleCount < this.visibleItems.length;
    }
  },
  watch: {
    messageQueueDeadLetters (newVal) {
      // Reset selectedItems when items prop changes
      this.selectedItems = this.initialSelectedItems;
    },
    initialSelectedItems (newVal) {
      // Sync with parent's selected items
      this.selectedItems = newVal;
    },
    selectedItems (newVal) {
      // Emit event to parent when selected items change
      this.$emit('update:selectedItems', newVal);
    }
  },
  methods: {
    onPaginationChange (pagination) {
      this.currentPage = pagination.page || 1;
      this.itemsPerPage = pagination.itemsPerPage || 10;
      this.filteredItems = pagination.filteredItems || [];
      // Clear selection when pagination changes
      this.selectedItems = [];
    },
    toggleSelectAll () {
      if (this.allSelected) {
        // Deselect all items
        this.selectedItems = [];
      } else {
        // Select all visible items on current page
        this.selectedItems = [...this.visibleItemIds];
      }
    },
    requeue (message) {
      this.$emit('requeueEvent', message);
    },
    remove (message) {
      this.$emit('removeEvent', message);
    },
    openJsonModal (item) {
      this.showModal = true;
      this.editorHeight = `${(window.innerHeight) * 0.60}px`;
      this.jsonModalTitle = `${item.Subscription} / ${item.Topic} / ${item.Id}`;
      this.message = JSON.parse(item.Message); // parsing so that we can pretty print the single line string
      // no clue why this is necessary, but it works
      this.$nextTick(() => {
          this.messageString = JSON.stringify(this.message, null, 2); // pretty print JSON
        });
    },
    closeModal () {
      this.showModal = false;
      this.messageString = null;
    }
  }
};
</script>
